<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column
            h1.title SCA IRGE &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.is-vcentered
          .column.is-2
            label.label Fecha de Inicio
            .field
              .control
                flat-pickr(
                  v-model='fechaInicio'
                  :config="config"
                  class="input"
                )
          .column.is-2
            label.label Fecha Final
            .field
              .control
                flat-pickr(
                  v-model='fechaFin'
                  :config="config"
                  class="input"
                )
          .column.is-2
            a.button.is-black.is-rounded(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
          .column.is-offset-1.is-1
            label.label Filtrar
          .column.is-3
            .field
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Buscar por usuario | embarque',
                  v-model="filter",
                )
          .column.is-1
            a.button.is-black(@click="descargarBitacora" :disabled="isDisabled")
              span.icon
                i.fas.fa-file-pdf
              | &nbsp Descargar
        .columns(v-show="mensajeError.length > 0")
          .column.is-5
            .notification.is-warning
              button.delete
              |   {{ mensajeError }}
        .columns(v-show="cambios.length > 0")
          .column.is-12
            Tb_Cambios(:cambios="cambiosShow")
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './cuartocontrol/layout/NavBar.vue'
  import Tb_Cambios from './Tb_Cambios.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import sca_irgeServices from '@/services/sca/irge.js'

  export default {
    name: 'Bitacora',
    components: { Loader, NavBar, flatPickr, Tb_Cambios },
    data() {
      return {
        isLoading: true,
        fechaInicio: moment().format('YYYY-MM-DD'),
        fechaFin: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        filter: '',
        cambios: [],
        cambiosShow: [],
        mensajeError: '',
        isDisabled: false,
      }
    },
    watch: {
      fechaInicio() {
        this.checarFechas()
      },
      fechaFin() {
        this.checarFechas()
      },
      filter() {
        const QUERY = this.filter.toUpperCase()
        const cambiosFilter = this.cambios.filter( cam => {
          return `${cam.embarque_cambio} ${cam.usuario_cambio} ${cam.cambios}`.toUpperCase().includes(QUERY)
        })
        console.log(cambiosFilter)
        this.cambiosShow = cambiosFilter
      },
    },
    methods: {
      iniciarComponente() {
        sca_irgeServices.getBitacora(this.fechaInicio, this.fechaFin)
          .then( data => {
            this.cambios = []
            this.cambiosShow = []
            this.cambios = data.map(this.convertirBitacora)
            this.cambiosShow = this.cambios
            this.isLoading = false
          })
          .catch(err => {
            this.displayToast('bubble', `Error2: ${err.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },
      convertirBitacora (cambio) {
        return {
          ...cambio,
          id_cambio: parseInt(cambio.id_cambio),
          embarque_cambio: parseInt(cambio.embarque_cambio),
          cambios: cambio.cambios.substring(0, (cambio.cambios.length - 3))
        }
      },
      backPage() {
        this.$router.back()
      },
      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      descargarBitacora() {
        if (this.isDisabled) return
        const currentUrl = window.location.hostname
        const protocol = window.location.protocol
        open(`${protocol}//${currentUrl}/servidores/reportes/bitacoraI.php?fI=${this.fechaInicio}&fF=${this.fechaFin}`)
      },
      checarFechas() {
        this.mensajeError = ''
        if (this.fechaInicio === this.fechaFin) {
          this.isDisabled = false
          this.iniciarComponente()
          return
        }
        const valida = moment(this.fechaInicio).isBefore(this.fechaFin)
        if (valida) {
          this.isDisabled = false
          this.iniciarComponente()
        } else {
          this.isDisabled = true
          this.cambios = []
          this.cambiosShow = []
          this.mensajeError = 'La fecha final debe ser igual o mayor a la fecha inicial'
        }
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/Bitacora.vue